"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = exports.closeHistory = exports.captureGlobalClick = void 0;
var _reduxActions = require("redux-actions");
var _connectedReactRouter = require("connected-react-router");
var _last2 = _interopRequireDefault(require("lodash/last"));
var _cccisdLaravelEventlog = require("cccisd-laravel-eventlog");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// If user has been staying on the page less than this time, then don't save it in url history
var limitTime = 500;

// Initial state
var initialState = exports.initialState = {
  urlHistory: [],
  globalClickCaptured: false
};

// Actions
var CLOSE_HISTORY = 'boilerplate/boilerplate/CLOSE_HISTORY';
var CAPTURE_GLOBAL_CLICK = 'boilerplate/boilerplate/CAPTURE_GLOBAL_CLICK';

// Action Creators
var closeHistory = exports.closeHistory = (0, _reduxActions.createAction)(CLOSE_HISTORY);
var captureGlobalClick = exports.captureGlobalClick = (0, _reduxActions.createAction)(CAPTURE_GLOBAL_CLICK);

// Reducer
var _default = exports["default"] = (0, _reduxActions.handleActions)(_defineProperty(_defineProperty(_defineProperty({}, _connectedReactRouter.LOCATION_CHANGE, function (state, action) {
  var currentTime = new Date().getTime();
  var lastUrl = (0, _last2["default"])(state.urlHistory);
  var previosTime = lastUrl ? lastUrl.time : 0;
  var pathname = action.payload.location.pathname;
  if (lastUrl && lastUrl.url === pathname) {
    return state;
  }
  var urlHistory = _toConsumableArray(state.urlHistory);
  if (currentTime - previosTime < limitTime) {
    urlHistory.pop();
  } else if (urlHistory.length > 0) {
    // Save pageVisit event
    var last = (0, _last2["default"])(urlHistory);
    (0, _cccisdLaravelEventlog.addEvent)({
      eventType: 'pageVisit',
      url: last.url,
      duration: currentTime - last.time
    });
  }
  urlHistory.push({
    url: pathname,
    time: currentTime
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    urlHistory: urlHistory
  });
}), CLOSE_HISTORY, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    urlHistory: [].concat(_toConsumableArray(state.urlHistory), [{
      url: 'some_fake_url',
      time: action.payload
    }])
  });
}), CAPTURE_GLOBAL_CLICK, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    globalClickCaptured: true
  });
}), initialState);